<template>
  <transition name="dialog-fade">
    <div class="zk-dialog__wrapper" v-show="value" @click.self="handleWrapperClick">
      <div
        class="zk-dialog"
        :class="[sizeClass, customClass]"
        ref="dialog"
        :style="style">
        <div class="zk-dialog__header">
          <span class="zk-dialog__title">{{title}}</span>
          <div class="zk-dialog__headerbtn">
            <i class="zk-dialog__close zk-icon zk-icon-close" @click='close()'></i>
          </div>
        </div>
        <div class="zk-dialog__body" v-if="rendered"><slot></slot></div>
        <div class="zk-dialog__footer" v-if="$slots.footer">
          <slot name="footer"></slot>
        </div>
      </div>
    </div>
  </transition>
</template>

<script>
  import Popup from 'vue-popup'

  export default {
    name: 'zk-dialog',

    mixins: [Popup],

    props: {
      title: {
        type: String,
        default: ''
      },

      modal: {
        type: Boolean,
        default: true
      },

      lockScroll: {
        type: Boolean,
        default: true
      },

      closeOnClickModal: {
        type: Boolean,
        default: true
      },

      closeOnPressEscape: {
        type: Boolean,
        default: true
      },

      size: {
        type: String,
        default: 'small'
      },

      customClass: {
        type: String,
        default: ''
      },

      top: {
        type: String,
        default: '15%'
      }
    },

    watch: {
      value(val) {
        if (val) {
          this.$emit('open')
          this.$nextTick(() => {
            this.$refs.dialog.scrollTop = 0
          })
        } else {
          this.$emit('close')
        }
      }
    },

    computed: {
      sizeClass() {
        return `zk-dialog--${ this.size }`
      },
      style() {
        return this.size === 'full' ? {} : { 'margin-bottom': '50px', 'top': this.top }
      }
    },

    methods: {
      handleWrapperClick() {
        if (this.closeOnClickModal) {
          this.$emit('input', false)
        }
      }
    },

    mounted() {
      if (this.value) {
        this.rendered = true
        this.open()
      }
    }
  }
</script>



// WEBPACK FOOTER //
// dialog.vue?c53d01d6